import React, { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export default function SummarySwirl({ className }: React.HTMLProps<HTMLDivElement>) {
  const { gsap } = useGSAP()

  const parentRef = useRef<HTMLDivElement>(null)
  const basePathRef = useRef<SVGPathElement>(null)
  const fullPathRef = useRef<SVGPathElement>(null)

  useLayoutEffect(() => {
    let ctx: gsap.Context = null
    const mm = gsap.matchMedia()

    const buildTimeline = (scrub: boolean) => {
      ctx = gsap.context(() => {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: parentRef.current,
              start: 'center bottom',
              end: 'center top+=20%',
              scrub,
            },
          })
          .fromTo(
            [basePathRef.current, fullPathRef.current],
            {
              drawSVG: '0% 0%',
            },
            {
              drawSVG: '0% 100%',
              duration: 0.66,
              ease: 'power1.inOut',
              stagger: 0.33,
            }
          )
          .to(
            [fullPathRef.current, basePathRef.current],
            {
              drawSVG: '100% 100%',
              duration: 0.66,
              ease: 'power1.inOut',
              stagger: 0.33,
            },
            '+=0.33'
          )
      })
    }
    const onResize = () => {
      ctx?.revert()
      mm.revert()

      mm.add('(prefers-reduced-motion: no-preference)', () => {
        buildTimeline(true)
      })
      mm.add('(prefers-reduced-motion: reduce)', () => {
        buildTimeline(false)
      })
    }

    window.addEventListener('resize', onResize)
    onResize()

    return () => {
      window.removeEventListener('resize', onResize)
      ctx?.revert()
      mm.revert()
    }
  }, [parentRef, basePathRef, fullPathRef, gsap])

  return (
    <div
      aria-hidden='true'
      ref={parentRef}
      className={`SummarySwirl pointer-events-none relative ${className ? className : ''}`}
    >
      <svg
        className='absolute z-2 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-48 md:w-60'
        viewBox='0 0 61 172'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          ref={basePathRef}
          d='M16.9789 1.39237C38.4696 41.0278 19.3167 142.013 2.88174 128.231C-11.3411 116.304 69.1158 72.2981 59.1331 171.56'
          stroke='currentColor'
          strokeWidth='2'
          className='opacity-10'
        />
        <path
          ref={fullPathRef}
          d='M16.9789 1.39237C38.4696 41.0278 19.3167 142.013 2.88174 128.231C-11.3411 116.304 69.1158 72.2981 59.1331 171.56'
          stroke='currentColor'
          strokeWidth='2'
        />
      </svg>
    </div>
  )
}
